import Vue from "vue";

Vue.directive('hide-once', {
  inserted: (el, binding, vnode, oldVnode) => {
    if (binding.value) {
      el.classList.add('hidden')
    }
  }
})
